import {Flex, Icon, Stack, StackProps} from "@chakra-ui/react";
import {
  HoverMenuItem,
  HoverMenuItemHeading,
  HoverMenuItemText,
  HoverMenuList,
  HoverMenuSeparator,
} from "../components/HoverMenu";
import {NewspaperIcon} from "@heroicons/react/24/outline";

const About = (props: StackProps) => (
  <HoverMenuList {...props}>
    <Stack separator={<HoverMenuSeparator />} gap={4}>
      <HoverMenuItem px={6} py={2} className="group">
        <Flex w={8} h={8} p={1.5} rounded="md" flexShrink={0} bgGradient="blue" align="center" justify="center">
          <Icon asChild fontSize="xl">
            <NewspaperIcon />
          </Icon>
        </Flex>
        <Stack gap={1}>
          <HoverMenuItemHeading to="/blog">Blog</HoverMenuItemHeading>
          <HoverMenuItemText>
            Insights on control testing, ISA 315 compliance and financial audit automation
          </HoverMenuItemText>
        </Stack>
      </HoverMenuItem>
    </Stack>
  </HoverMenuList>
);
export default About;
